import React from 'react';
import { observer } from 'mobx-react';
import { Col, Grid } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { truncate } from '../../utils/stringUtils';

@observer
export default class TrendsFeatured extends React.Component {
    render() {
        const post = this.props.store.mainFeature;
        let truncatedSummary = '';

        let linkHref = `/trend/${post.blogPostUrlPath}`;

        if (post.summary) {
            truncatedSummary = truncate(post.summary, 400);
        }

        return (
            <Col xs={12} componentClass="section" className="featured-post">
                <Grid>
                    <Col xs={12} sm={6}>
                        <Link to={linkHref} className="post-link">
                            <h1>{post.title}</h1>
                        </Link>
                        <p>{truncatedSummary}</p>
                        <Link to={linkHref} className="underline-link dark">
                            Read more
                        </Link>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Link to={linkHref}>
                            <img
                                src={post.imageUrl}
                                alt={post.title}
                                className="img-responsive"
                            />
                        </Link>
                    </Col>
                </Grid>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/TrendsFeatured.jsx